<template>
  <div class="modal fade" id="selectSendCv" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="example-Modal3">选择简历</h5>
          <button type="button" class="close" ref="closeMyApply" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="form-group">
          <select id="my-cv-list" class="form-control custom-select" v-model="selectCvId">
            <option value="">--请选择--</option>
            <option v-for='v in simpleCvList' :value="v.id" v-text="v.name"></option>
          </select></div>
        <div class="modal-footer">
          <button type="button" class="btn btn-twitter" v-on:click="sendCv">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import {getSimpleCvList, applyNewJob} from '@/api/job'
    import Toastr from "toastr2";

    export default {
        name: 'sc_cv',
        props: [],
        components: {},
        data() {
            return {
                simpleCvList: [],
                selectCvId:"",
                targetJobId:"",
                targetFairId:""
            }
        },
        mounted() {
        },
        methods: {
            getMyCvs(targetJobId, targetFairId) {
                this.targetJobId = targetJobId;
                this.targetFairId = targetFairId;
                getSimpleCvList().then(response => {
                    this.simpleCvList = response.cvList
                }).catch(error => {
                })
            },
            sendCv() {
                const toast = new Toastr()
                if (this.selectCvId == "") {
                    toast.warning("请选择发送的简历!!!")
                    return
                }
                var data = {}
                data['jobId'] = this.targetJobId;
                data['cvId'] = this.selectCvId;
                data['fairId'] = this.targetFairId;
                applyNewJob(data).then(response => {
                    $('#selectSendCv').modal('hide');
                    toast.info("简历发送成功!!!")
                }).catch(error => {
                })

            }
        }
    }
</script>

<style scoped>
  .btn-success {
    color: #fff;
    background: #9ac043;
    border-color: #9ac043;
  }
</style>



// WEBPACK FOOTER //
// src/views/fair/commons/select_cv.vue